// extracted by mini-css-extract-plugin
module.exports = {"buttonGradient":"styles_buttonGradient__2NTAd","buttonWhite":"styles_buttonWhite__1TGD0","disabled":"styles_disabled__w0lkX","control":"styles_control__2CxPk"};